<template>
  <v-card class="docuforms matter-engagement-tab">
    <div class="docuforms-panels-wrapper">
      <ExpansionPanels
        :items="docuformsTabSections"
        :multiple="false"
        :disable-hover="false"
        :on-hover-color="hoverColor"
        @panel-change="panelChanged"
        :direction="direction">
        <template slot="content"
                  slot-scope="contentSlot">
          <DocuformsList :initiator="contentSlot.item.id"
                         :refreshId="refreshId"/>
        </template>
      </ExpansionPanels>
    </div>

    <FabBtn
      v-if="(!hasNewShareDialog && !hasEsign) || isMobile"
      :bgColor="secondaryColor"
      :textColor="textColor"
      custom-class="bottom-right"
      @click="fabButtonAddDoc()"
      icon="icon-documents-plus"/>

    <v-tooltip v-else
               top
               content-class="fab-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="fab-btn bottom-right add-docuforms-btn-desktop"
              v-bind="attrs"
              v-on="on">
          <DropdownMenu
            :top="true"
            :left="!isRightToLeft"
            :right="isRightToLeft"
            :offsetY="true"
            :items="actions"
            @item-clicked="actionsClicked">
            <v-btn :color="secondaryColor" rounded fab>
              <v-icon :color="textColor">icon-documents-plus</v-icon>
            </v-btn>
          </DropdownMenu>
        </span>
      </template>
      <span>{{$t('client.matters.matter_page.fabs.documents')}}</span>
    </v-tooltip>

  </v-card>
</template>

<script>
import {mapGetters} from "vuex";
import {FabBtn, ExpansionPanels, DropdownMenu} from "@/modules/common/components"
import {DOCUFORMS_TAB_SECTIONS} from "@/modules/matters/components/docuforms/constants"
import DocuformsList from "@/modules/matters/components/docuforms/DocuformsList"
import matterActionsService from "@/modules/matters/services/matterActionsService";

export default {
  name: "Docuforms",
  components: {
    FabBtn,
    ExpansionPanels,
    DocuformsList,
    DropdownMenu
  },
  data() {
    return {
      activePanel: 0,
      refreshId: +new Date()
    }
  },
  methods: {
    fabButtonAddDoc() {
      this.$frontageApi.send('matter_action', {action: 'add_document', origin: 'Docuforms tab fab'});
    },
    panelChanged(index) {
      this.activePanel = index
    },
    actionsClicked(e) {
      this.$frontageApi.send('matter_action', {action: 'all_actions', action_name: e.action, origin: 'Docuforms tab fab'});
    }
  },
  computed: {
    ...mapGetters(['isRightToLeft', 'direction', 'isMobile']),
    ...mapGetters("brandModule", ["hoverColor", "secondaryColor", "textColor"]),
    docuformsTabSections() {
      return DOCUFORMS_TAB_SECTIONS.map(item => ({...item, name: this.$t(item.name)}));
    },
    hasNewShareDialog() {
      return this.$hasFeature('new_share_dialog');
    },
    hasEsign() {
      return this.$hasFeature('e_sign');
    },
    actions() {
      let actions = [];

      if (this.hasNewShareDialog) {
        actions.push('share_document', 'internal_document');
      } else {
        actions.push('document');
      }

      if (this.hasEsign) {
        actions.push('request_signature');
      }

      return matterActionsService.getActions(...actions);
    }
  }
}
</script>

<style scoped lang="scss">
.docuforms {

  &.matter-engagement-tab {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: inherit;

    ::v-deep .v-expansion-panel-content {
      overflow-y: auto;
      max-height: calc(100vh - 328px);

      .matter-page-wrapper & {
        max-height: calc(100vh - 306px)
      }

      .mobile-view & {
        max-height: calc(100vh - 264px)
      }
    }

    .docuforms-panels-wrapper {
      flex: 1;
    }
  }

  .add-docuforms-btn-desktop {
    position: absolute;
  }
}
</style>
